var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        _vm._l(_vm.guardians, function(guardian, index) {
          return _vm.isNewRow(index)
            ? _c("div", { key: guardian.id, staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("guardian-component", {
                      attrs: {
                        firstname: guardian.firstname,
                        lastname: guardian.lastname,
                        address: guardian.address,
                        extraAddressLine: guardian.extraAddressLine,
                        zipcode: guardian.zipcode,
                        city: guardian.city,
                        email: guardian.email,
                        mobile: guardian.mobile,
                        phone: guardian.phone,
                        website: guardian.website
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col delete-guardian-link" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                _vm.deleteGuardianDialog(guardian.id)
                              }
                            }
                          },
                          [
                            _c("icon", { attrs: { name: "trash-o" } }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("guardians.deleteButton")) +
                                "\n                        "
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    index < _vm.guardians.length - 1
                      ? _c("guardian-component", {
                          attrs: {
                            firstname: _vm.guardians[index + 1].firstname,
                            lastname: _vm.guardians[index + 1].lastname,
                            address: _vm.guardians[index + 1].address,
                            extraAddressLine:
                              _vm.guardians[index + 1].extraAddressLine,
                            zipcode: _vm.guardians[index + 1].zipcode,
                            city: _vm.guardians[index + 1].city,
                            email: _vm.guardians[index + 1].email,
                            mobile: _vm.guardians[index + 1].mobile,
                            phone: _vm.guardians[index + 1].phone,
                            website: _vm.guardians[index + 1].website
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.guardians.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col delete-guardian-link" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function($event) {
                                      _vm.deleteGuardianDialog(
                                        _vm.guardians[index + 1].id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("icon", { attrs: { name: "trash-o" } }),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("guardians.deleteButton")) +
                                      "\n                        "
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "add-guardian-link" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.add-guardian-modal",
                    modifiers: { "add-guardian-modal": true }
                  }
                ],
                attrs: { href: "javascript:void(0)" }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("guardians.addGuardianButton")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "add-guardian-modal",
          attrs: {
            id: "add-guardian-modal",
            "ok-title": "Speichern",
            "cancel-title": "Abbrechen",
            "hide-header": true,
            "hide-footer": true
          }
        },
        [_c("add-guardian-component")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b109919", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b109919","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/GuardiansComponent.vue
// module id = null
// module chunks = 